<script>
  import { showCircleStyling, setCircleSettings, showSettingsPopup } from '../service/LmsUIService';
  import AccessLevelPicker from '../utils/AccessLevelPicker.svelte';
  import { ignore } from '../../Common/tools';
  import { External, M } from '../../external';
  import Categories from './Categories.svelte';
  import TagAndAutoresponderListPicker from '../../Common/TagAndAutoresponderListPicker.svelte';
  import RequestAccessQuestionnaire from './RequestAccessQuestionnaire.svelte';

  export let circle,
    isTemplate = false,
    onChange = () => {};

  let circleSettings = setCircleSettings(circle);

  let notifyChanged = () => {
    circleSettings = setCircleSettings(circle);
    onChange(false);
  };

  const editRequestAccess = () => {
    showSettingsPopup({
      width: 420,
      component: (target) =>
        new RequestAccessQuestionnaire({
          target: target,
          props: {
            circle: circle,
            onChange: (requestAccess) => {
              circle.settings.requestAccess = requestAccess;
              notifyChanged();
            }
          }
        })
    });
  };

  let showCircleStylingFromCircleSettings = () => {
    showCircleStyling(circle, ignore, () => {
      onChange(true);
    });
  };

  let onUrlKeyUp = () => {
    circle.url = External.Tools.urlFromString(circle.url, false, false, '_', true);
  };

  let pickCategory = () => {
    External.Tools.showWindow({
      isModal: false,
      withDarkBackground: true,
      width: 420,
      buttons: [],
      noNav: true,
      noTitle: true,
      //forceAtRight: window.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, ui) => {
          popup.bindComponent(
            new Categories({
              target: popup.getContentArea(),
              props: {
                selectedIds: circle.categories || [],
                onChange: (selectedIds) => {
                  circle.categories = selectedIds;
                  onChange(false);
                }
              }
            })
          );
        }
      }
    });
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-5">
    <span class="material-icons-outlined fingerprint-icon"> hdr_weak </span>
  </div>
  <h4 class="col20 f-left mt-15 mb-25 t-center h4-bigger">{M.CRICLE_SETTINGS}</h4>
  <div class="popup-input-wrapper">
    <h5>{M.CIRCLE_NAME}</h5>
    <input type="text" placeholder={M.ENTER_DISPLAY_NAME} bind:value={circle.name} on:change={notifyChanged} />
  </div>
  <div class="popup-input-wrapper">
    <h5>{M.CIRCLE_URL}</h5>
    <input
      type="text"
      placeholder={M.ENTER_CIRCLE_URL}
      bind:value={circle.url}
      on:keyup={onUrlKeyUp}
      on:change={notifyChanged} />
  </div>
  <div class="popup-input-wrapper mt-5">
    <h5>{M.CIRCLE_DESCRIPTION}</h5>
    <input
      bind:value={circle.description}
      on:change={notifyChanged}
      type="text"
      name="circleDescription"
      placeholder={M.ENTER_DISPLAY_DESCRIPTION} />
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input
        id="showCircleAvatar"
        class="css-checkbox"
        type="checkbox"
        bind:checked={circleSettings.showCircleAvatar}
        on:change={notifyChanged} />
      <label for="showCircleAvatar" class="css-label"
        >{M.SHOW_CIRCLE_AVATAR}
        <span>{M.SHOW_CIRCLE_AVATAR_DESC}</span></label>
    </div>
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input
        id="lmsShowCircleMembers"
        class="css-checkbox"
        type="checkbox"
        bind:checked={circleSettings.showCircleMember}
        on:change={notifyChanged} />
      <label for="lmsShowCircleMembers" class="css-label"
        >{M.SHOW_CIRCLE_MEMBERS}
        <span>{M.SHOW_CIRCLE_MEMBERS_DESC}</span></label>
    </div>
  </div>
  {#if circleSettings.showCircleMember}
    <div class="col20 f-left">
      <div class="checkbox-wrapper">
        <input
          id="lmsShowCircleMemberCountInNavigation"
          class="css-checkbox"
          type="checkbox"
          bind:checked={circleSettings.showCircleMemberCountInNavigation}
          on:change={notifyChanged} />
        <label for="lmsShowCircleMemberCountInNavigation" class="css-label"
          >{M.SHOW_CIRCLE_MEMBERS_IN_NAVIGATION}
          <span>{M.SHOW_CIRCLE_MEMBERS_IN_NAVIGATION_DESC}</span></label>
      </div>
    </div>
  {/if}

  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input
        id="lmsShowCircleDesc"
        class="css-checkbox"
        type="checkbox"
        name="lmsShowCircleDesc"
        bind:checked={circleSettings.showDescription}
        on:change={notifyChanged} />
      <label for="lmsShowCircleDesc" class="css-label"
        >{M.SHOW_CIRCLE_DESCRIPTION}
        <span>{M.SHOW_CIRCLE_DESCRIPTION_DESC}</span></label>
    </div>
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input
        id="lmsInnerCircleTrackingProgress"
        class="css-checkbox"
        type="checkbox"
        name="circlePageDescription"
        bind:checked={circleSettings.showTrackingProgress}
        on:change={notifyChanged} />
      <label for="lmsInnerCircleTrackingProgress" class="css-label"
        >{M.SHOW_TRACKING_PROGRESS}
        <span>{M.SHOW_TRACKING_PROGRESS_DESC}</span></label>
    </div>
  </div>

  <div class="popup-input-wrapper f-left mt-5">
    <AccessLevelPicker {isTemplate} item={circle} type="CIRCLE" onChange={notifyChanged} />
  </div>
  <div class="col20 f-left">
    <div class="checkbox-wrapper">
      <input
        id="lmsEnrollRequired"
        class="css-checkbox"
        type="checkbox"
        name="lmEnrollRequired"
        bind:checked={circle.enroll}
        on:change={notifyChanged} />
      <label for="lmsEnrollRequired" class="css-label"
        >{M.ENROLLMENT_REQUIRED}
        <span>{M.ENROLLMENT_REQUIRED_DESC}</span>
      </label>
    </div>
  </div>
  {#if circle.enroll && circle.access.type !== 'PAID'}
    <div class="col20 f-left">
      <div class="checkbox-wrapper">
        <input
          id="lmsEnableAccessRequest"
          class="css-checkbox"
          type="checkbox"
          name="lmsEnableAccessRequest"
          bind:checked={circleSettings.requestAccess.enabled} />
        <label for="lmsEnableAccessRequest" class="css-label"
          >{M.ENABLE_REQUEST_ACCESS}
          <span>{M.ENABLE_REQUEST_ACCESS_DESC}</span>
        </label>
      </div>
    </div>
    {#if circleSettings.requestAccess.enabled}
      <div class="col20 f-left mb-10">
        <a on:click={editRequestAccess} class="middle-button blue">{M.CONFIGURE_REQUEST_ACCESS}</a>
      </div>
    {/if}
  {/if}
  {#if !isTemplate}
    <div class="col20 f-left gray-section product-select-wrapper mb-10">
      <div class="col20 f-left ab-step center-vertically">
        <h4 class="roboto">{M.CIRCLE_CATEGORIES}</h4>
        <a on:click={pickCategory} class="text-link blue-text">{M.CHANGE}</a>
      </div>
    </div>
  {/if}
  <div class="col20 f-left gray-section product-select-wrapper mb-10">
    <div class="col20 f-left ab-step center-vertically">
      <h4 class="roboto">{M.CIRCLE_STYLING}</h4>
      <a on:click={showCircleStylingFromCircleSettings} class="text-link blue-text">{M.STYLE}</a>
    </div>
  </div>

  <TagAndAutoresponderListPicker
    data={circleSettings}
    onChange={notifyChanged}
    thirdPartyMarketing={false}
    label={M.WHEN_ENROLLED_TITLE}
    description={M.WHEN_ENROLLED_DESC} />
</div>
